(function () {
  'use strict';

  angular.module('ringbaPortal').component('blockedNumbers', {
    controller: BlockedNumbersController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/numbers/blocked-numbers.view.html'
  });

  function BlockedNumbersController(
    _,
    accountsService,
    campaignServiceVue,
    blockedNumberService,
    isMobileDevice,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.unblockNumber = unblockNumber;
    vm.onFormSubmit = onFormSubmit;
    vm.getDateObject = getDateObject;
    vm.activateBlockedNumberActions = activateBlockedNumberActions;

    function onInit() {
      vm.isMobileView = isMobileDevice;
      vm.loading = true;
      _loadCampaigns().then(function () {
        _loadBlockedNumbers();
      });
    }

    function showForm(blockedNumber) {
      if (!vm.formActive) {
        if (blockedNumber) {
          blockedNumber.showEditForm = true;
        } else {
          vm.showAddNewForm = true;
        }
        vm.activeActionBlockedNumberId = false;
        vm.formActive = true;
      }
    }

    function hideForm(event, blockedNumber) {
      if (blockedNumber) {
        blockedNumber.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
    }

    function unblockNumber(id) {
      if (vm.formActive) {
        return;
      }
      blockedNumberService.deleteBlockedNumber(accountsService.currentAccountId, id).then(function () {
        _loadBlockedNumbers();
        toaster.pop('success', 'Number successfully unblocked');
      }).catch(utils.errorHandler);
    }

    function onFormSubmit(blockedNumber) {
      hideForm(null, blockedNumber);
      _loadBlockedNumbers();
    }

    function getDateObject(row) {
      return row.timeLimited ? new Date(row.expiration) : new Date(new Date().setFullYear(9999));
    }

    function activateBlockedNumberActions(blockedNumberId) {
      if (!vm.formActive) {
        vm.activeActionBlockedNumberId = vm.activeActionBlockedNumberId == blockedNumberId ? false : blockedNumberId;
      }
    }

    function _loadBlockedNumbers() {
      blockedNumberService.getBlockedNumbers(accountsService.currentAccountId).then(function (blockedNumbers) {
        vm.loading = false;
        if (!vm.campaignHashmap) {
          vm.campaignHashmap = _.keyBy(vm.campaigns, function(campaign) {
            return campaign.id;
          });
        }
        _.forEach(blockedNumbers, function (blockedNumber) {
          if (blockedNumber.campaignId && vm.campaignHashmap[blockedNumber.campaignId]) {
            blockedNumber.campaignName = vm.campaignHashmap[blockedNumber.campaignId].name;
          }
        });
        vm.blockedNumbers = blockedNumbers;
      });
    }

    function _loadCampaigns() {
      return campaignServiceVue.getBasicCompletedCampaigns(accountsService.currentAccountId).then(function (campaigns) {
        vm.campaigns = campaigns;
      });
    }

  }
})();
